module.exports = __webpack_public_path__ + "img/SignIn-icon.5014f445.svg";